// Generated by Claude Code
import { createFileRoute } from '@tanstack/react-router'
import { GeneralSettingsPage } from '#components/domain/operations/settings/general/general-settings-page.tsx'

export const Route = createFileRoute('/_appSettings/$companyId/settings/general')({
  component: GeneralSettingsPage,
})
